var exports = {
  "uW": "PlusAppearanceSettings.module__section___TC0teD",
  "DD": "PlusAppearanceSettings.module__title___TC0teD",
  "h_": "PlusAppearanceSettings.module__description___TC0teD",
  "Os": "PlusAppearanceSettings.module__group___TC0teD",
  "Pf": "PlusAppearanceSettings.module__label___TC0teD",
  "qW": "PlusAppearanceSettings.module__fontGrid___TC0teD",
  "s_": "PlusAppearanceSettings.module__fontSample___TC0teD",
  "_v": "PlusAppearanceSettings.module__fontSampleGradient___TC0teD",
  "_r": "PlusAppearanceSettings.module__fontSampleDefaultOnLight___TC0teD",
  "VH": "PlusAppearanceSettings.module__preview___TC0teD",
  "B0": "PlusAppearanceSettings.module__previewCard___TC0teD",
  "gz": "PlusAppearanceSettings.module__previewName___TC0teD",
  "V": "PlusAppearanceSettings.module__modeGroup___TC0teD",
  "KW": "PlusAppearanceSettings.module__colorRow___TC0teD",
  "v2": "PlusAppearanceSettings.module__contrast___TC0teD",
  "Vi": "PlusAppearanceSettings.module__contrastWarning___TC0teD",
  "v4": "PlusAppearanceSettings.module__presets___TC0teD",
  "IS": "PlusAppearanceSettings.module__preset___TC0teD",
  "rM": "PlusAppearanceSettings.module__presetSelected___TC0teD",
  "gJ": "PlusAppearanceSettings.module__errorMessage___TC0teD",
};

module.exports = exports;
